
class Login extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.recoveryForm = this.element.querySelector("#ForgotPass");
    this.loginForm = this.element.querySelector("#logIn");

    if (window.location.href.indexOf("recover") != -1) {
      this.openRecover();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
        "click",
        '[data-action="toggle-recovery"]',
        this.openRecover.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="toggle-login"]',
        this.openLogin.bind(this)
    );

    this.delegateElement.on(
      'click', 
      '[data-action="submit-register"]', 
      this.submitRegistration.bind(this)
    );

    this.delegateElement.on(
      'click', 
      '[data-action="submit-login"]', 
      this.submitLogin.bind(this)
    );

    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
  }

  connectedCallback() {
    this.initFormValidation();
  }

  openRecover(event = null) {
    if (event) event.preventDefault();
    this.recoveryForm.setAttribute('aria-hidden', 'false');
    this.loginForm.setAttribute('aria-hidden', 'true');
  }

  openLogin(event = null) {
    if (event) event.preventDefault();
    this.recoveryForm.setAttribute('aria-hidden', 'true');
    this.loginForm.setAttribute('aria-hidden', 'false');
  }

  initFormValidation() {
    const forms = {
      login: { el: "#customer_login", button: ".acc_login-btn", error: ".input-validation" },
      register: { el: "#register_form", button: ".acc_login-btn, .Button--auth", error: ".registerErrors" },
      recover: { el: "#recover_form", button: ".acc_forgot-btn", error: "#RecoverEmail-email-error" },
      reset: { el: "#reset_form", button: ".acc_reset-btn", error: ".input-validation" },
      activate_account: { el: "#activate-account", button: ".activate-account__submit", error: ".input-validation" }
    };

    for (const [key, { el, button, error }] of Object.entries(forms)) {
      const form = this.querySelector(el);
      if (!form) continue;

      this[`${key}Validator`] = new FormValidator(form, {
        errorClass: "field--error",
        fieldSelector: ".field",
        buttonSelector: button,
        fieldErrorSelector: error,
        validateOnBlur: true,
        validateOnInput: false,
        showErrorsOnSubmitOnly: false
      });
    }
  }

  async submitRegistration(event) {
    event.preventDefault();
    const registrationEndpoint = `${window.routes.localeRootUrl}/account`;
    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: this.element.querySelector("#RegisterForm-email").value,
        password: this.element.querySelector("#RegisterForm-password").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loader = event.target.closest("form").querySelector(".itemLoader");
    loader.classList.add("is-visible");

    try {
      const response = await fetch(registrationEndpoint, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const registerEmailError = this.element.querySelector("#RegisterForm-email-error");
      const registerPasswordError = this.element.querySelector("#RegisterForm-password-error");
      const generalError = this.element.querySelector('#register .drawer__errors');

      if (responseText.indexOf("registerErrors") !== -1) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        const emailErrorElement = tempDiv.querySelector("#RegisterForm-email-error");
        const emailInput = this.element.querySelector("#RegisterForm-email");
        const emailField = emailInput.closest(".field");
        if (emailErrorElement) {
          registerEmailError.setAttribute("aria-hidden", "false");
          registerEmailError.innerHTML = emailErrorElement.innerHTML;
          emailInput.setAttribute("aria-invalid", "true");
          emailField.classList.add("input--error");
        } else {
          emailInput.setAttribute("aria-invalid", "false");
          registerEmailError.setAttribute("aria-hidden", "true");
          emailField.classList.remove("input--error");
        }

        const passwordErrorElement = tempDiv.querySelector("#RegisterForm-password-error");
        const passwordInput = this.element.querySelector("#RegisterForm-password");
        const passwordField = passwordInput.closest(".field");
        if (passwordErrorElement) {
          registerPasswordError.setAttribute("aria-hidden", "false");
          registerPasswordError.style.display = "block";
          registerPasswordError.innerHTML = passwordErrorElement.innerHTML;
          passwordInput.setAttribute("aria-invalid", "true");
          passwordField.classList.add("input--error");
        } else {
          registerPasswordError.setAttribute("aria-hidden", "true");
          passwordInput.setAttribute("aria-invalid", "false");
          passwordField.classList.remove("input--error");
        }

        const generalErrorNew = tempDiv.querySelector("#account__register-email-error");
        if (generalErrorNew) {
          generalError.setAttribute("aria-hidden", "false");
          generalError.style.display = "block";
          generalError.innerHTML = generalErrorNew.innerHTML;
        }
      } else {

        if (registerPasswordError) {
          registerPasswordError.setAttribute("aria-hidden", "true");
        }

        this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
        this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
        if (registerEmailError) {
          registerEmailError.setAttribute("aria-hidden", "true");
        }


        location.href = window.routes.account_url;
      }
    } catch (error) {
      console.error("Registration error:", error);
    } finally {
      loader.classList.remove("is-visible");
    }
  }

  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loginButton = this.element.querySelector('[data-action="submit-login"]');
    console.log(loginButton, " login button ");
    const loader = loginButton ? loginButton.querySelector(".itemLoader") : null;
    console.log(loader, " loader ");
    loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
        const loginError = this.element.querySelector("#login .accountDrawer--ErrorSpace");
        loginError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;
        loginError.innerHTML = tempDiv.querySelector(".AlertError").innerHTML;
        loginError.classList.add("is-visible");

        const fieldErr = loginError.closest('.field');
        if (fieldErr) fieldErr.classList.add('input--error');
      } else {
        location.href = window.routes.account_url;
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      loader.classList.remove("is-visible");
    }
  }

  accountInputSubmit(e) { if (e.key === "Enter") this.submitLogin(e); }
  accountInputSubmitReg(e) { if (e.key === "Enter") this.submitRegistration(e); }
  accountInputSubmitForgot(e) { if (e.key === "Enter") { e.preventDefault(); this.accountRecover(e); } }

}

customElements.define("customer-login", Login);

class AccountComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.delegateBody = new Delegate(document.body);

    this.stickyAddNewWrapper = this.element.querySelector('.customer-account__add-new-sticky');
    this.addNewBtn = this.element.querySelector('.customer-account__add-new');

    this.drawerEl = document.querySelector('#modal-address-new');
    this.customerInfoDrawer = document.querySelector('#edit-customer-info');
    this.editDrawers = document.querySelectorAll('[id^="edit-address-"]');
    this.drawer = new Drawer(this.drawerEl);

    new Drawer(this.customerInfoDrawer)
    this.editDrawers.forEach((elem) => {
      new Drawer(elem);
    })

    this._cleanupFunctions = [];

    this.bindEvents();
  }

  connectedCallback() {
    // this.initFormValidation();
    this.handleRefreshState();
  }

  disconnectedCallback() {
    this._cleanupFunctions.forEach(cleanup => cleanup());
    this._cleanupFunctions = [];
  }

   debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  bindEvents() {

    this.delegateBody.on("drawer:open", this.formValidationOn.bind(this));

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on("click", '[data-action="delete-address"]', this.deleteAddress.bind(this));

    if (this.stickyAddNewWrapper) {
      scrollListener.addScrollListener(this, this.showStickyAddNew.bind(this));
    }

    this.delegateElement.on(
        "click",
        '[data-action="set-default-address"]',
        this.handleDefaultButton.bind(this)
    )
  }


  handleDefaultButton(e){
    e.preventDefault();
   e.target.classList.toggle("is-active");

   e.target.closest("form").submit();
  }
  formValidationOn (event) {

    const id = event.detail.drawerId
    this.initFormValidation(id)
  }

  initFormValidation(id) {

    const addressId = id.split("edit-address-")[1];
    const forms = {
      edit_customer: {el: "#edit-info", button: ".edit-info", error: ".input-validation"},
      add_address: { el: "#add-address", button: ".add-address-btn", error: ".input-validation" },
      edit_address: { el: `#edit-address-form-${addressId}`, button: `.edit-address-btn-${addressId}`, error: ".input-validation" }
    };

    for (const [key, { el, button, error }] of Object.entries(forms)) {


      let form = this.querySelector(el);

      if (!form) continue;

      this[`${key}Validator`] = new FormValidator(form, {
        errorClass: "field--error",
        fieldSelector: ".field",
        buttonSelector: button,
        fieldErrorSelector: error,
        validateOnBlur: true,
        validateOnInput: false,
        showErrorsOnSubmitOnly: false
      });
    }
  }


  showStickyAddNew() {
    const options = { root: null, threshold: 0 };
    let mainVisible = false;
    let footerVisible = false;

    const footerEl = document.querySelector('footer');
    const isDebugMode = window.location.search.includes('debug=sticky');

    const updateSticky = this.debounce(() => {
      const shouldHide = mainVisible || footerVisible;
      this.stickyAddNewWrapper.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');

      if (isDebugMode) {
        console.log('🏷️ Sticky ATC:', { mainVisible, footerVisible, shouldHide });
      }
    }, 50);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.target === this.addNewBtn) {
          mainVisible = entry.isIntersecting;
        } else if (entry.target === footerEl) {
          footerVisible = entry.isIntersecting;
        }
      });
      updateSticky();
    }, options);

    if (this.addNewBtn) observer.observe(this.addNewBtn);
    if (footerEl) observer.observe(footerEl);

    this._cleanupFunctions.push(() => observer.disconnect());
  }

  handleRefreshState() {
    if (responsive.matchesBreakpoint('lap_and_up')) {
      const contactInfo = this.element.querySelector('#contactInfo')

          if(contactInfo){
            contactInfo.setAttribute('aria-visible', 'true');
          }
    }

    const searchParams = new URLSearchParams(window.location.search);
    const param1Value = searchParams.get('location');

    if (param1Value) {
      this.toggleTab(false, param1Value);
    } else {
      this.toggleTab(false, 'contactInfo');
    }
  }

  deleteAddress(event) {
    const id = event.target.getAttribute("data-id");
    Shopify.postLink("/account/addresses/" + id, { parameters: { _method: "delete" } });
    setTimeout(() => {
      const currentUrl = new URL(window.location.href);
      window.location.href = currentUrl.href;
    }, 500);
  }


  toggleTab(event, paramValue) {
    let id = paramValue;
    if (event) {
      id = event.target.dataset.id;
    }

    const allContent = this.element.querySelectorAll('.customer-account__content');
    const menuTab = this.element.querySelector('.customer-account__tab');
    let allTabs;
    let activeTab;
    if(!responsive.matchesBreakpoint('lap_and_up')) {
      allTabs = this.element.querySelectorAll('.customer-account__tabs[data-swiper-mobile] .customer-account__tab.swiper-slide');
      activeTab = this.element.querySelector(`.customer-account__tabs[data-swiper-mobile] [data-id="${id}"]`);
    }

    else{
      allTabs = this.element.querySelectorAll('.customer-account__tabs.not_mobile .customer-account__tab');
      activeTab = this.element.querySelector(`.customer-account__tabs.not_mobile [data-id="${id}"]`);

    }

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    if (activeTab) {
      activeTab.setAttribute('aria-expanded', 'true');
      activeTab.classList.add('account-menu_active');
    }

    allContent.forEach((content) => {
        content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }

    const currentUrl = window.location.href.split('?')[0];
    const newUrl = `${currentUrl}?location=${id}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
}

customElements.define("account-component-inner", AccountComponent);
